export default {"src":"/_next/static/media/the-launch-market_small-logo.58b2e013.svg","height":441,"width":1080,"blurWidth":0,"blurHeight":0};